module.exports = __webpack_public_path__ + "assets/3bf18e9816c69931a583fa1bdea97b03.mp4";